<template>
  <div class="flex-grid">
    <div class="col2">
      <div class="main_heading">
        <h3>Menu Access For Roles</h3>
        <a
          class="button_create"
          href="/menus/"
        >Manage Menu's</a>
        <a
          class="button_create"
          href="/roles/"
        >Manage Roles</a>
      </div>
      <div class="form-fields">
        <label for="roleName">
          <b>Select Role</b>
        </label>
        <select
          v-model="roleId"
          @change="selectRole()"
        >
          <option value>
            Select Role
          </option>
          <option
            v-for="(role, key) in rolesList"
            :key="key"
            :value="role.roleId"
          >
            {{ role.roleName }}
          </option>
        </select>
      </div>
      <div class="form-fields">
        <div
          v-for="(menu, key) in menusList"
          :key="key"
        >
          <span class="toggle-arrow">></span>
          <input
            type="checkBox"
            :value="menu.id"
            :checked="menu.access"
            @change="selectMenus(key)"
          >
          {{ menu.name }}
          <ul>
            <li
              v-for="(submenu, key1) in menu.submenus"
              :key="key1"
            >
              <span class="toggle-arrow">></span>
              <input
                :id="submenu._id"
                type="checkBox"
                :value="submenu._id"
                :checked="submenu.access"
                @change="selectSubMenus(key,key1)"
              >
              {{ submenu.menu_name }}
              <ul>
                <li
                  v-for="(action, key2) in actions"
                  :key="key2"
                  style="display: inline-block;"
                >
                  <input
                    type="checkBox"
                    :value="action"
                    :checked="submenu.actions.indexOf(action)!=-1"
                    @change="selectActions(key,key1,action)"
                  >
                  {{ action }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <a
        class="button_create"
        @click="saveAccess()"
      >Save</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MenuAccess',
  data() {
    return {
      isUpdate: false,
      menusList: [],
      menuType: 'submenu',
      rolesList: [],
      roleId: '',
      parentMenus: [],
      actions: ['ADD', 'UPDATE', 'VIEW'],
      menuName: '',
      menuIds: [],
      menuController: '',
      menuURL: '',
      menuDescription: '',
    };
  },
  mounted() {
    this.isUpdate = true;
    const getRole = fetch('/api/roles/all', { credentials: 'same-origin' });
    getRole
      .then(data => data.json())
      .then((data) => {
        this.rolesList = data;
      });
  },
  methods: {
    selectMenus(index) {
      if (this.menusList[index].access) {
        this.menusList[index].access = false;
        this.menusList[index].submenus.forEach((element) => {
          const accessElement = element;
          accessElement.access = false;
          accessElement.actions.splice(0, 3);
        });
      } else {
        this.menusList[index].access = true;
        this.menusList[index].submenus.forEach((element) => {
          const accessElement = element;
          accessElement.access = true;
          accessElement.actions.push('ADD', 'UPDATE', 'VIEW');
        });
      }
    },
    selectActions(mIndex, sIndex, action) {
      const index = this.menusList[mIndex].submenus[sIndex].actions.indexOf(
        action,
      );
      if (index !== -1) {
        this.menusList[mIndex].submenus[sIndex].actions.splice(index, 1);
      } else {
        this.menusList[mIndex].submenus[sIndex].actions.push(action);
      }
    },
    selectSubMenus(mIndex, index) {
      const submenuaccess = this.menusList[mIndex].submenus[index].access;
      if (submenuaccess) {
        this.menusList[mIndex].submenus[index].access = false;
        this.menusList[mIndex].submenus[index].actions.splice(0, 3);
      } else {
        this.menusList[mIndex].submenus[index].access = true;
        this.menusList[mIndex].submenus[index].actions.push(
          'ADD',
          'UPDATE',
          'VIEW',
        );
      }
    },
    selectRole() {
      const getRolewiseAccess = fetch(
        `/api/rolewiseMenuAccess/${this.roleId}`,
        { credentials: 'same-origin' },
      );
      getRolewiseAccess
        .then(data => data.json())
        .then((data) => {
          this.menusList = JSON.parse(data.menu_access);
        });
    },
    saveAccess() {
      const url = `/api/rolewiseMenuAccess/${this.roleId}`;
      const data = {
        id: this.roleId,
        menuAccess: JSON.stringify(this.menusList),
        actions: this.actions,
      };

      fetch(url, {
        method: 'PUT', // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then(response => this.$toasted.success(response.message, { duration: 3000 }));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.toggle-arrow {
  cursor: pointer;
  font-weight: bold;
  font-size: 20px;
}

.flex-grid {
  display: flex;
  justify-content: space-between;
}

.col2 {
  width: 100%;
}

.form-fields {
  padding: 5px;
}
.form-fields ul ul {
  margin-bottom: 10px;
}
.form-fields ul ul li {
  text-transform: lowercase;
}
</style>
